import { render, staticRenderFns } from "./icon-btn.vue?vue&type=template&id=65e45829&scoped=true"
import script from "./icon-btn.vue?vue&type=script&lang=js"
export * from "./icon-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e45829",
  null
  
)

export default component.exports